import { Exclude } from 'class-transformer';

export class WorkflowCheckListItemResultDto {
    id: number;
    title: string;
    helpId: number;
    allowedStatusOptionCodes: Array<string>;

    // Transient
    @Exclude()
    camStatus: string;
    @Exclude()
    camComments: string;
    @Exclude()
    acctStatus: string;
    @Exclude()
    acctComments: string;
}
